import { Link } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import { LegalHeading } from '@/components/legal/LegalHeading';
import { LegalText } from '@/components/legal/LegalText';
import { ObfuscatedEmail } from '@/components/legal/ObfuscatedEmail';
import { RouterLink } from '@/components/router/RouterLink';
import { makeMetaTitle, META_ROBOTS_NOINDEX } from '@/modules/META';

export const Route = createFileRoute('/_content/impressum')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  head: () => ({
    meta: [makeMetaTitle(['Impressum']), META_ROBOTS_NOINDEX],
  }),
});

function RouteComponent() {
  return (
    <Fragment>
      <LegalHeading level="h1" sx={{ marginTop: 0 }}>
        Impressum
      </LegalHeading>
      <LegalText>
        <b> Angaben gemäß § 5 TMG</b> <br />
        Ministerium für Verkehr Baden-Württemberg <br />
        Abteilung 5 <br />
        Dorotheenstraße 8 <br />
        70173 Stuttgart <br />
        <br />
        <b>Kontakt:</b>
        <br />
        E-Mail: <ObfuscatedEmail name="poststelle" />
      </LegalText>
      <LegalHeading level="h1">Haftungsausschluss</LegalHeading>
      <LegalHeading>Haftung für Inhalte</LegalHeading>
      <LegalText>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
        rechtswidrige Tätigkeit hinweisen.
        <br />
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
        hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
        Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
        umgehend entfernen.
      </LegalText>
      <LegalHeading>Haftung für Links</LegalHeading>
      <LegalText>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
        können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
        stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
        Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
        Verlinkung nicht erkennbar.
        <br />
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
        Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
        entfernen.
      </LegalText>
      <LegalHeading>Urheberrecht</LegalHeading>
      <LegalText>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
        Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
        des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und
        Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
        dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
        Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
        werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
        derartige Inhalte umgehend entfernen.
      </LegalText>
      <LegalHeading>Datenschutz</LegalHeading>
      <LegalText>
        Informationen zum Datenschutz finden Sie in unserer{' '}
        <RouterLink to="/datenschutz">Datenschutzerklärung</RouterLink>.
      </LegalText>
      <LegalHeading>Quellenvermerk</LegalHeading>
      <LegalText>Die Kartendarstellung beruht auf Grundlage von</LegalText>
      <LegalText component="ul">
        <li>
          <Link href="https://www.lgl-bw.de/">LGL Baden-Württemberg</Link>
        </li>
        <li>
          <Link href="https://basemap.de/">basemap.de</Link>
        </li>
      </LegalText>
    </Fragment>
  );
}
